import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom'

import Home from './Home'
import SideNav from './SideNav'
import Questions from './Questions'
import Footer from './Footer'
import PageNotFound from './PageNotFound'

import '../scss/styles.scss'


function App() {
    return <>
        <Router>
            <SideNav />

            <main role="main">
                <Switch>
                    <Route path="/" component={Home} exact />
                    <Route path="/questions">
                        <Questions />
                    </Route>
                    <Route path="/" component={PageNotFound}/>
                </Switch>
            </main>
        </Router>

        <Footer />
    </>
}

export default App
